export default __webpack_public_path__ + "static/media/nonstandard_image.0fad5c0b.svg";